export default __webpack_public_path__ + "static/media/97.95dca713.jpg";